/* eslint-disable @typescript-eslint/consistent-type-imports */
/* eslint-disable @typescript-eslint/unbound-method */
import { Component, type OnInit } from '@angular/core';

import { catchError, concatMap, EMPTY, map, of, type Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';
import { GsIconListComponent } from '../../shared/components/gs-icon-list/gs-icon-list.component';
import { GSIconListBulletModel, GSIconListModel } from '../../shared/components/gs-icon-list/gs-icon-list.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AuthService } from '../../shared/services/auth.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
import { Nav } from '../../shared/enums/nav.enum';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { RegisterAccount } from '../../shared/models/register-account';
import { postalCodeValidator } from '../../shared/validators/postalCode.validator';
import { CustomerClassEnum } from '../../shared/enums/customerclass.enum';
import { SeoService } from '../../shared/services/seo.service';
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { AccountService } from '../../shared/services/account.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    GsIconListComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    NotificationComponent,
  ],
})
export class RegisterComponent implements OnInit {
  pageLabels: any;
  pageReady = false;
  registerForm!: FormGroup;
  apiErrors: any[] = [];
  apiError: string = '';
  formErrorMessage: string = '';
  hasLessthanTenChar = false;
  radioSelected: string = 'RES';
  pageName = 'Register';
  STACCustomerError = '';

  constructor(
    private readonly cms: CmsService,
    private readonly auth: AuthService,
    private readonly formBuilder: FormBuilder,
    // eslint-disable-next-line @typescript-eslint/prefer-readonly
    private router: Router,
    private readonly utils: UtilService,
    private readonly storage: StorageService,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
    private readonly account: AccountService,
  ) {}

  ngOnInit(): void {
    this.cms
      .getContent('oas-register', 'register')
      .pipe(
        map((data: any) => {
          const unmappedListData = data.bulletList.value.data;
          const listData = new GSIconListModel();
          listData.Header = unmappedListData.header;
          listData.Subheader = unmappedListData.subheader;

          const bulletList: GSIconListBulletModel[] = [];
          unmappedListData?.bulletList?.forEach((bullet: any) => {
            const bulletObj = new GSIconListBulletModel();
            bulletObj.BulletText = bullet.bullet.bulletText;
            bulletObj.BulletTitle = bullet.bullet.bulletTitle;
            bulletObj.IconPath = bullet.bullet.iconPath;
            bulletObj.IconAltText = bullet.bullet.iconAltText;
            bulletObj.ShowBullet = bullet.bullet.showBullet;

            bulletList.push(bulletObj);
          });

          listData.BulletList = bulletList;

          const newDataObj = JSON.parse(JSON.stringify(data));
          newDataObj.accountBenefitsList = listData;

          this.seoS.setSeoTags(data.seo);

          this.pageLabels = newDataObj;
          return newDataObj;
        }),
      )
      .subscribe((res: any) => {
        // Initialize the form group with reactive validators
        this.registerForm = this.formBuilder.group({
          CustomerClassRadio: [CustomerClassEnum.RES, Validators.required],
          accountNumber: ['', [Validators.required, Validators.minLength(10), this.validateAccountNumber.bind(this)]],
          ssnPin: ['', [Validators.required, Validators.minLength(4), this.validateSSNPin.bind(this)]],
        });
        this.STACCustomerError = this.pageLabels.stacCustomerError;
        this.pageReady = true;
        this.utils.hideSpinner();
      });
  }

  get accountNumber(): FormControl {
    return this.registerForm.get('accountNumber') as FormControl;
  }

  get ssnPin(): FormControl {
    return this.registerForm.get('ssnPin') as FormControl;
  }

  get CustomerClassRadio(): FormControl {
    return this.registerForm.get('CustomerClassRadio') as FormControl;
  }

  get postalCode(): FormControl {
    return this.registerForm.get('postalCode') as FormControl;
  }

  onSubmit(): void {
    this.apiError = '';
    this.formErrorMessage = '';
    if (this.registerForm.valid) {
      this.utils.showSpinner();
      this.apiErrors = this.storage.getSession(StorageEnum.GlobalVars).apiErrors;
      const registerAccountReq = new RegisterAccount();
      registerAccountReq.AccountNumber = this.accountNumber.value;
      registerAccountReq.CustomerClass = this.CustomerClassRadio.value;
      if (this.radioSelected === CustomerClassEnum.RES) {
        registerAccountReq.IdNumber = this.ssnPin.value;
      } else {
        registerAccountReq.PostalCode = this.postalCode.value;
      }

      // Only call unauthAccountCharacteristics if radioSelected is not RES
      let initialObservable$: Observable<any>;
      if (this.radioSelected !== CustomerClassEnum.RES) {
        initialObservable$ = this.account.unauthAccountCharacteristics(this.accountNumber.value);
      } else {
        initialObservable$ = of(null);
      }

      initialObservable$
        .pipe(
          catchError((e) => {
            return of('error getting account characteristics');
          }),
          concatMap((data: any) => {
            // Only check accountCharacteristic if we called unauthAccountCharacteristics
            if (data !== null) {
              const cmstacRecord = data.accountCharacteristic?.find(
                (characteristic: any) => characteristic.characteristicType === 'CMSTAC',
              );
              if (cmstacRecord) {
                this.showAPIErrorLabel(this.STACCustomerError);
                this.utils.hideSpinner();
                return EMPTY;
              }
            }
            return this.auth.registerAccount(registerAccountReq).pipe(
              catchError((e) => {
                this.utils.consoleGroup('error:', e);
                const errorCode = e.message;
                const newApiError = this.apiErrors.find((error) => {
                  return error.apiError.errorCode === errorCode;
                });
                if (newApiError === undefined) {
                  const genericApiError = this.apiErrors.find((error) => {
                    return error.apiError.errorCode === 'NCR30003';
                  });
                  this.showAPIErrorLabel(genericApiError.apiError.displayMessage);
                } else {
                  if (
                    newApiError.apiError.errorCode === 'NCR30004' &&
                    registerAccountReq.CustomerClass === CustomerClassEnum.RES
                  ) {
                    newApiError.apiError.displayMessage = newApiError.apiError.displayMessage.replaceAll(
                      '{0}',
                      'business',
                    );
                  } else if (
                    newApiError.apiError.errorCode === 'NCR30004' &&
                    registerAccountReq.CustomerClass === CustomerClassEnum.SMLCOM
                  ) {
                    newApiError.apiError.displayMessage = newApiError.apiError.displayMessage.replaceAll(
                      '{0}',
                      'residential',
                    );
                  } else if (
                    newApiError.apiError.errorCode === 'NCR30003' &&
                    registerAccountReq.CustomerClass === CustomerClassEnum.RES
                  ) {
                    newApiError.apiError.displayMessage = newApiError.apiError.displayMessage.replace('{0}', 'SSN/PIN');
                  } else if (
                    newApiError.apiError.errorCode === 'NCR30003' &&
                    registerAccountReq.CustomerClass === CustomerClassEnum.SMLCOM
                  ) {
                    newApiError.apiError.displayMessage = newApiError.apiError.displayMessage.replace(
                      '{0}',
                      'mailing zip code',
                    );
                  }
                  this.showAPIErrorLabel(newApiError.apiError.displayMessage);
                }
                this.utils.hideSpinner();
                return EMPTY;
              }),
            );
          }),
        )
        .subscribe(() => {
          void this.router.navigateByUrl(
            Nav.RegisterAccount +
              '?accountNumber=' +
              registerAccountReq.AccountNumber +
              '&customerClass=' +
              registerAccountReq.CustomerClass,
          );
        });
    } else {
      // Mark all controls as touched to trigger validation messages
      this.registerForm.markAllAsTouched();
      this.showFormErrorLabel();
    }
  }

  showFormErrorLabel(): void {
    this.formErrorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
    if (this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  showAPIErrorLabel(errMsg: string): void {
    this.apiError = errMsg;
    if (this.apiError !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.apiError, NotificationType.Error, this.pageName);
    }
  }

  async goToLogin(): Promise<void> {
    await this.router.navigateByUrl(Nav.Login);
  }

  logDebug(data: any): void {
    this.utils.consoleGroup('Login icon-list Debug Data', data);
  }

  validateAccountNumber(control: AbstractControl): ValidationErrors | null {
    const accountNumRegex = /^[0-9]*$/;
    const value = control.value;
    if (!accountNumRegex.test(value)) {
      return { invalidAccount: true };
    }
    return null;
  }

  validateSSNPin(control: AbstractControl): ValidationErrors | null {
    const accountNumRegex = /^[0-9]*$/;
    const value = control.value;
    if (!accountNumRegex.test(value)) {
      return { invalidSSNPin: true };
    }
    return null;
  }

  updateForm(value: any): void {
    this.radioSelected = value;
    if (value === CustomerClassEnum.RES) {
      this.registerForm = this.formBuilder.group({
        CustomerClassRadio: [CustomerClassEnum.RES, Validators.required],
        accountNumber: ['', [Validators.required, Validators.minLength(10), this.validateAccountNumber.bind(this)]],
        ssnPin: ['', [Validators.required, Validators.minLength(4), this.validateSSNPin.bind(this)]],
      });
    } else {
      this.registerForm = this.formBuilder.group({
        CustomerClassRadio: [CustomerClassEnum.SMLCOM, Validators.required],
        accountNumber: ['', [Validators.required, Validators.minLength(10)]],
        postalCode: ['', [Validators.required, Validators.minLength(5), postalCodeValidator()]],
      });
    }
  }
}
